// components/CustomModal.jsx
import { Modal, Button } from 'react-bootstrap';
import { useState, useEffect } from 'react';
import axios from 'axios';
import { api} from '../../../utils/variables';
import { Spinner } from 'reactstrap';
import SkeletonCard from '../../../pages/KeywordTracking/components/SkeletonCard';

const KeywordTrackingLandingPageModal = ({ show, handleClose, title, children, itemId, tagType = 'KEYWORD' }) => {
  const [tags, setTags] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredTags, setFilteredTags] = useState([]);
  const [movingItem, setMovingItem] = useState(null);

  // Fetch tags from API
  const fetchTags = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem('authToken');
      const response = await axios.get(`${api}/tracker/tags.keywords?tag_type=${tagType}`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Accept': 'application/json'
        }
      });

      if (response.data && response.data.data) {
        setTags(response.data.data);
        setFilteredTags(response.data.data);
      }
    } catch (error) {
      console.error(`Error fetching ${tagType} tags:`, error);
    } finally {
      setLoading(false);
    }
  };

  // Handle move item to selected tag
  const handleMoveToTag = async (tag) => {
    if (!itemId) {
      console.error('No item ID provided for moving');
      return;
    }


    const isAlreadyInGroup = tag.game_ids && tag.game_ids.includes(itemId);
    if (isAlreadyInGroup) {
      alert('This item is already in the selected group.');
      return;
    }

    setMovingItem(tag.name);

    try {
      const token = localStorage.getItem('authToken');

      // Find current tag for the item
      const currentTag = tags.find(k => k.game_ids && k.game_ids.includes(itemId));

      // Remove from current tag if exists
      if (currentTag && currentTag.name !== tag.name) {
        try {
          await axios.patch(`${api}/tracker/tags.keywords/${encodeURIComponent(currentTag.name)}/?tag_type=${tagType}`, {
            item_id: itemId,
            tag_name: currentTag.name,
            tag_type: tagType
          }, {
            headers: {
              'Authorization': `Bearer ${token}`,
              'Content-Type': 'application/json'
            }
          });
        } catch (patchError) {
          console.error('Error removing from current group:', patchError);
        }
      }

      // Add item to new tag
      await axios.post(`${api}/tracker/tags.keywords/`, {
        item_id: itemId,
        tag_name: tag.name,
        tag_type: tagType
      }, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      handleClose();

      // Trigger refresh in parent component
      if (typeof window !== 'undefined') {
        window.dispatchEvent(new CustomEvent('keywordGroupsUpdated'));
      }

    } catch (error) {
      console.error('Error moving item:', error);
      alert(error.response?.data?.message || `Failed to move item to ${tagType} group.`);
    } finally {
      setMovingItem(null);
    }
  };

  // Filter tags based on search term
  const handleSearch = () => {
    if (!searchTerm.trim()) {
      setFilteredTags(tags);
      return;
    }
    const filtered = tags.filter(tag => tag.name.toLowerCase().includes(searchTerm.toLowerCase()));
    setFilteredTags(filtered);
  };

  const handleSearchInputChange = (e) => {
    setSearchTerm(e.target.value);
    if (!e.target.value.trim()) {
      setFilteredTags(tags);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') handleSearch();
  };

  useEffect(() => {
    if (show) fetchTags();
  }, [show, tagType]);

  return (
    <Modal show={show} onHide={handleClose} centered size="lg" className='modal_key'>
      {title && (
        <Modal.Header closeButton>
          <Modal.Title>Select a {tagType === 'CATEGORY' ? 'Category' : 'Group'}</Modal.Title>
        </Modal.Header>
      )}
      <Modal.Body>
        <div className="key_track_search" style={{ maxWidth: "100%" }}>
          <div className="key_track_search_inn">
            <i className="fa-solid fa-magnifying-glass"></i>
            <input
              type="text"
              placeholder={`Enter ${tagType === 'CATEGORY' ? 'Category' : 'Group'} Name`}
              value={searchTerm}
              onChange={handleSearchInputChange}
              onKeyPress={handleKeyPress}
            />
            <button onClick={handleSearch} disabled={loading}>
              {loading ? <Spinner size="sm" color="light" /> : 'Search'}
            </button>
          </div>

          <div className='grp_result_btm'>
            <h6>Search result</h6>
            {loading ? <SkeletonCard /> :
              filteredTags.length > 0 ? (
                filteredTags.map((tag, index) => (
                  <div key={index} className='grp_result_btm_box'>
                    <div className='grp_result_btm_box_lt'>
                      <h4>{tag.name}</h4>
                      <p>{tag.game_ids ? tag.game_ids.length : 0} Apps</p>
                    </div>
                    <div className='grp_result_btm_box_rt'>
                      <a
                        href='#'
                        onClick={(e) => {
                          e.preventDefault();
                          if (!(tag.game_ids && tag.game_ids.includes(itemId))) {
                            handleMoveToTag(tag);
                          }
                        }}
                        style={{
                          color: tag.game_ids && tag.game_ids.includes(itemId) ? '#6c757d' : '#007bff',
                          cursor: (movingItem === tag.name || (tag.game_ids && tag.game_ids.includes(itemId))) ? 'not-allowed' : 'pointer',
                          pointerEvents: (movingItem === tag.name || (tag.game_ids && tag.game_ids.includes(itemId))) ? 'none' : 'auto'
                        }}
                      >
                        {movingItem === tag.name ? <Spinner size="sm" color="primary" /> :
                          tag.game_ids && tag.game_ids.includes(itemId) ? 'Already in group' : 'Move here'}
                      </a>
                    </div>
                  </div>
                ))
              ) : (
                <div style={{ textAlign: 'center', padding: '20px', color: '#666' }}>
                  {searchTerm ? `No ${tagType === 'CATEGORY' ? 'categories' : 'groups'} found matching your search.` : `No ${tagType === 'CATEGORY' ? 'categories' : 'groups'} available.`}
                </div>
              )}
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default KeywordTrackingLandingPageModal;

// // components/CustomModal.jsx
// import { Modal, Button } from 'react-bootstrap';
// import { useState, useEffect } from 'react';
// import axios from 'axios';
// import { api } from '../../../utils/variables';
// import { Spinner } from 'reactstrap';
// import SkeletonCard from '../../../pages/KeywordTracking/components/SkeletonCard';

// const KeywordTrackingLandingPageModal = ({ show, handleClose, title, children, itemId }) => {
//   const [keywords, setKeywords] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [searchTerm, setSearchTerm] = useState('');
//   const [filteredKeywords, setFilteredKeywords] = useState([]);
//   const [movingItem, setMovingItem] = useState(null);

//   // Fetch keywords from API
//   const fetchKeywords = async () => {
//     setLoading(true);
//     try {
//       const token = localStorage.getItem('authToken');
//       const response = await axios.get(`${api}/tracker/tags.keywords?tag_type=KEYWORD`, {
//         headers: {
//           'Authorization': `Bearer ${token}`,
//           'Accept': 'application/json'
//         }
//       });

//       if (response.data && response.data.data) {
//         setKeywords(response.data.data);
//         setFilteredKeywords(response.data.data);
//       }
//     } catch (error) {
//       console.error('Error fetching keywords:', error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Handle move item to selected tag
//   const handleMoveToTag = async (keyword) => {
//     if (!itemId) {
//       console.error('No item ID provided for moving');
//       return;
//     }

//     console.log('Moving item:', itemId, 'to group:', keyword.name);
//     console.log('Available keywords:', keywords);

//     // Check if item is already in this group
//     const isAlreadyInGroup = keyword.game_ids && keyword.game_ids.includes(itemId);
//     if (isAlreadyInGroup) {
//       alert('This item is already in the selected group.');
//       return;
//     }

//     setMovingItem(keyword.name);
    
//     try {
//       const token = localStorage.getItem('authToken');
      
//       // Step 1: Find which tag the item currently belongs to
//       const currentTag = keywords.find(k => k.game_ids && k.game_ids.includes(itemId));
//       console.log('Current tag found:', currentTag);
      
//       // Step 2: If item is in a different group, delete it from current group first
//       if (currentTag && currentTag.name !== keyword.name) {
//         console.log(`Removing item ${itemId} from group: ${currentTag.name}`);
//         try {
//           const patchUrl = `${api}/tracker/tags.keywords/${encodeURIComponent(currentTag.name)}/?tag_type=KEYWORD`;
//           console.log('PATCH URL:', patchUrl);
          
//           await axios.patch(patchUrl, {
//             item_id: itemId,
//             tag_name: currentTag.name,
//             tag_type: "KEYWORD"
//           }, {
//             headers: {
//               'Authorization': `Bearer ${token}`,
//               'Content-Type': 'application/json'
//             }
//           });
//           console.log('Successfully removed from current group');
//         } catch (patchError) {
//           console.error('Error removing from current group:', patchError);
//           console.error('Patch error response:', patchError.response?.data);
//           // Continue anyway - the item might not be in any group
//         }
//       }

//       // Step 3: Add item to selected tag
//       console.log(`Adding item ${itemId} to group: ${keyword.name}`);
//       const addResponse = await axios.post(`${api}/tracker/tags.keywords/`, {
//         item_id: itemId,
//         tag_name: keyword.name,
//         tag_type: "KEYWORD"
//       }, {
//         headers: {
//           'Authorization': `Bearer ${token}`,
//           'Content-Type': 'application/json'
//         }
//       });

//       console.log('Successfully added to new group:', addResponse.data);

//       // Step 4: Close modal and refresh data
//       handleClose();
      
//       // Trigger a callback to refresh parent component data
//       if (typeof window !== 'undefined') {
//         window.dispatchEvent(new CustomEvent('keywordGroupsUpdated'));
//       }

//     } catch (error) {
//       console.error('Error moving item to tag:', error);
//       console.error('Error response:', error.response?.data);
//       console.error('Error status:', error.response?.status);
      
//       // More specific error message
//       let errorMessage = 'Failed to move item to selected group. Please try again.';
//       if (error.response?.data?.message) {
//         errorMessage = error.response.data.message;
//       } else if (error.response?.status === 400) {
//         errorMessage = 'Invalid request. Please check the group name and try again.';
//       } else if (error.response?.status === 404) {
//         errorMessage = 'Group not found. Please try again.';
//       } else if (error.response?.status === 409) {
//         errorMessage = 'Item is already in this group.';
//       }
      
//       alert(errorMessage);
//     } finally {
//       setMovingItem(null);
//     }
//   };

//   // Filter keywords based on search term
//   const handleSearch = () => {
//     if (!searchTerm.trim()) {
//       setFilteredKeywords(keywords);
//       return;
//     }

//     const filtered = keywords.filter(keyword => 
//       keyword.name.toLowerCase().includes(searchTerm.toLowerCase())
//     );
//     setFilteredKeywords(filtered);
//   };

//   // Handle search input change
//   const handleSearchInputChange = (e) => {
//     setSearchTerm(e.target.value);
//     if (!e.target.value.trim()) {
//       setFilteredKeywords(keywords);
//     }
//   };

//   // Handle search on Enter key press
//   const handleKeyPress = (e) => {
//     if (e.key === 'Enter') {
//       handleSearch();
//     }
//   };

//   // Fetch keywords when modal opens
//   useEffect(() => {
//     if (show) {
//       fetchKeywords();
//     }
//   }, [show]);



//   return (
//     <Modal show={show} onHide={handleClose} centered size="lg" className='modal_key'>
//       {title && (
//         <Modal.Header closeButton>
//           <Modal.Title>Select a Group</Modal.Title>
//         </Modal.Header>
//       )}
//       <Modal.Body>
//         <div className="key_track_search" style={{maxWidth:"100%"}}>
//             <div className="key_track_search_inn"> 
//               <i className="fa-solid fa-magnifying-glass"></i> 
//                 <input 
//                   type="text" 
//                   placeholder="Enter Group Name"
//                   value={searchTerm}
//                   onChange={handleSearchInputChange}
//                   onKeyPress={handleKeyPress}
//                 />                 
                
//               <button onClick={handleSearch} disabled={loading}>
//                 {loading ? (
//                   <Spinner size="sm" color="light" />
//                 ) : (
//                   'Search'
//                 )}
//               </button>

//             </div>
//             <div className='grp_result_btm'>
//                 <h6>Search result</h6>
//                 {loading ? (
//                   <div>
//                     <SkeletonCard />
//                   </div>
//                 ) : filteredKeywords.length > 0 ? (
//                   filteredKeywords.map((keyword, index) => (
//                     <div key={index} className='grp_result_btm_box'>
//                         <div className='grp_result_btm_box_lt'>
//                             <h4>{keyword.name}</h4>
//                             <p>{keyword.game_ids ? keyword.game_ids.length : 0} Apps</p>
//                         </div>
//                         <div className='grp_result_btm_box_rt'>
//                             <a 
//                               href='#'
//                               onClick={(e) => {
//                                 e.preventDefault();
//                                 if (!(keyword.game_ids && keyword.game_ids.includes(itemId))) {
//                                   handleMoveToTag(keyword);
//                                 }
//                               }}
//                               style={{
//                                 color: keyword.game_ids && keyword.game_ids.includes(itemId) ? '#6c757d' : '#007bff',
//                                 cursor: (movingItem === keyword.name || (keyword.game_ids && keyword.game_ids.includes(itemId))) ? 'not-allowed' : 'pointer',
//                                 pointerEvents: (movingItem === keyword.name || (keyword.game_ids && keyword.game_ids.includes(itemId))) ? 'none' : 'auto'
//                               }}
//                             >
//                               {movingItem === keyword.name ? (
//                                 <Spinner size="sm" color="primary" />
//                               ) : keyword.game_ids && keyword.game_ids.includes(itemId) ? (
//                                 'Already in group'
//                               ) : (
//                                 'Move here'
//                               )}
//                             </a>
//                         </div>
//                     </div>
//                   ))
//                 ) : (
//                   <div style={{ textAlign: 'center', padding: '20px', color: '#666' }}>
//                     {searchTerm ? 'No keywords found matching your search.' : 'No keywords available.'}
//                   </div>
//                 )}
//             </div>
//           </div>
//       </Modal.Body>
     
//     </Modal>
//   );
// };

// export default KeywordTrackingLandingPageModal;
